/**
 * @readonly
 * @member {string} owner
 * @member {string} type
 */
export default class KeyDto {
  owner
  type

  /**
   * @param {string} owner
   * @param {string} type
   */
  constructor({ owner, type }) {
    const properties = {
      configurable: false,
      enumerable: true,
      writable: false
    }

    owner = String(owner)
    type = String(type)

    Object.defineProperty(this, 'owner', Object.assign({ value: owner }, properties))
    Object.defineProperty(this, 'type', Object.assign({ value: type }, properties))
    Object.freeze(this)
  }
}
